import Button from './button';
import Menu from './menu';
import Modal from './modal';
import Tooltip from './tooltip';

export default { Button, Modal, Menu, Tooltip };
